export const ADVERT = "advert"
export const USER = "user"
